import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockLevelDisplay implements BaseEnumType {
  private static allValues: EnumStockLevelDisplay[] = []; // make sure this is top-most
  
  public static off = new EnumStockLevelDisplay(0, "Off", "enum_stock_level_display_off");
  public static showCount = new EnumStockLevelDisplay(1, "ShowCount", "enum_stock_level_display_show_count");
  public static showStatus = new EnumStockLevelDisplay(2, "ShowStatus", "enum_stock_level_display_show_status");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockLevelDisplay.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOff() { return this === EnumStockLevelDisplay.off; }
  public isShowCount() { return this === EnumStockLevelDisplay.showCount; }
  public isShowStatus() { return this === EnumStockLevelDisplay.showStatus; }

  public static getValues(): readonly EnumStockLevelDisplay[] {
    return EnumStockLevelDisplay.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockLevelDisplay[] {
    return EnumStockLevelDisplay.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockLevelDisplay {
    const found = EnumStockLevelDisplay.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockLevelDisplay - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockLevelDisplay): EnumStockLevelDisplay {
    const found = name ? EnumStockLevelDisplay.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockLevelDisplay - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockLevelDisplay>): boolean {
    return this.key === other?.key;
  }
}